import {ErrorsOr, flattenArrayOfErrorsOr, mapErrorsOr} from "@me8eon/errors";
import {AiToolArgsSchema} from "@me8eon/aiclient";

export type MessageRole = "user" | "system" | "assistant" | "tool";

export type Message = BaseMessage | ToolMessage | AssistantMessageRequest;

export const defaultAction = "default";

type TextMessage = {
    type: "text"
    text: string
}

type ImageMessage = {
    type: "image_url"
    image_url: {
        url: string
    }
}

export type BaseMessage = {
    content: string | Array<TextMessage | ImageMessage>
    role: MessageRole
    source?: Source[]
    agent?: string
    action?: string
}

export type ToolCall = {
    tool_name: string
    tool_call_id: string
    tool_args: AiToolArgsSchema
}
export type AssistantMessageRequest = {
    role: "assistant"
    toolCalls: ToolCall[]
    content: ''
}

export function isAssistantMessageRequest(message: Message): message is AssistantMessageRequest {
    return message.role === "assistant" && (message as any).toolCalls !== undefined;
}

export type ToolMessage = {
    role: "tool"
    content: string
    tool_call_id: string
}

export type ElasticSearchSource = {
    type: "elasticsearch"
    index: string, id: string, url?: string
}

export type Source = string | ElasticSearchSource


export const mapMessages = (messages: BaseMessage[], fn: (context: string) => string): BaseMessage[] => messages.map((message) =>
    ({...message, content: fn(message?.content as string)})
);

export const mapMessagesErrorsOr = (messages: Message[], fn: (context: string) => ErrorsOr<string>): ErrorsOr<Message[]> =>
    flattenArrayOfErrorsOr(messages.map<ErrorsOr<Message>>((message) => isAssistantMessageRequest(message)
        ? {value: message}
        : mapErrorsOr(fn(message?.content as string), (content) => ({...message, content}))));


export const normaliseMessage = (msg: Message): Message => {
    if (isAssistantMessageRequest(msg)) return {role: "assistant", toolCalls: msg.toolCalls, content: ''};
    if (msg.role === "tool") return {
        role: "tool",
        tool_call_id: (msg as ToolMessage).tool_call_id,
        content: (msg as ToolMessage).content
    };
    return {role: msg.role, content: msg.content?.toString() || ''}
};

export function normaliseMessages(messages: Message[]): Message[] {
    return messages.map(normaliseMessage);
}


